import React from 'react';

import { IconCheckbox } from '../../IconCheckbox';
import { Text, TextVariant } from '../../Text';
import * as styles from './Checkbox.module.scss';

/**
 * This components accepts a ref that's passed to the checkbox input,
 * it's meant to be used with react-hooks-form
 */

type InputProps = {
  defaultChecked?: boolean;
  checked: boolean;
  label: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

export const Checkbox = React.forwardRef<HTMLInputElement, InputProps>(
  ({ checked, label, defaultChecked = false, ...rest }, ref): JSX.Element => {
    return (
      <>
        <input
          id={label}
          hidden
          type="checkbox"
          ref={ref}
          defaultChecked={defaultChecked}
          {...rest}
        />
        {}
        <Text
          className={styles.label}
          tag="label"
          variant={TextVariant.BODY_SMALL}
          htmlFor={label}
        >
          <IconCheckbox checked={checked} />
          {label || null}
        </Text>
      </>
    );
  },
);
